import * as Stimulus from "@hotwired/stimulus"

/**
 * Controls dismissable page elements. Elements are removed
 * from the DOM when the dismiss action is fired.
 **/
export class FormController extends Stimulus.Controller {
    static targets = [ "fieldset", "submit" ]

    enableSubmit() {
        if(this.hasSubmitTarget) {
            this.submitTarget.disabled = false;
        }
    }

    toggleFieldset(e) {
        if(!e.params.selector || e.target.type !== "checkbox") {
            return
        }

        let fieldset = this.fieldsetTargets.find(el => el.matches(e.params.selector))
        if(fieldset) {
            fieldset.disabled = !e.target.checked;
        }
    }

    submit(e) {
        let firstInvalidTarget;
        for(const $target of this.fieldsetTargets) {
            const targetEvent = this.dispatch("submit", { target: $target });
            if(targetEvent.defaultPrevented && !firstInvalidTarget) {
                firstInvalidTarget = $target;
            }
        }

        if(firstInvalidTarget) {
            firstInvalidTarget.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
            e.preventDefault();
        }
    }
}
